import Lottie from "lottie-react";
import closeIcon from "../../../../appAssets/closeIcon.png";
import WebShadowButton from "../../../WebStoryScreen/Components/WebShadowButton";
import "./ModeDialog.scss";
import { meditatingYeti, giftIcon } from "../../../../appAssets/jsons";

interface ModeDialogProps {
  onSelect: (mode: "mindfulBreathing" | "surpriseMe") => void;
  onClose: () => void;
}

function ModeDialog({ onSelect, onClose }: ModeDialogProps) {
  return (
    <div className="mode-dialog__overlay">
      {/* Mirrors breathe__header: spacer | title | close */}
      <div className="mode-dialog__header">
        <div />
        <h2 className="mode-dialog__title">How would you like to relax?</h2>
        <button
          type="button"
          className="mode-dialog__close"
          onClick={onClose}
          aria-label="Close"
        >
          <img
            src={closeIcon}
            alt="Close"
            className="mode-dialog__close-icon"
          />
        </button>
      </div>

      <div className="mode-dialog__options">
        <WebShadowButton
          variant="outline"
          icon={
            <Lottie
              animationData={meditatingYeti}
              loop={false}
              autoplay={false}
              className="mode-dialog__option-lottie"
            />
          }
          title="Mindful breathing"
          onPress={() => onSelect("mindfulBreathing")}
          className="mode-dialog__option"
        />

        <WebShadowButton
          variant="outline"
          icon={
            <Lottie
              animationData={giftIcon}
              loop
              autoplay
              className="mode-dialog__option-lottie"
            />
          }
          title="Surprise me"
          onPress={() => onSelect("surpriseMe")}
          className="mode-dialog__option"
        />
      </div>
    </div>
  );
}

export default ModeDialog;
